import { Dependency, featureProvider } from '@onxmaps/feature-access'
import { FishClaims, FishGates } from '@/services/feature-access/fish/types'
import {
  resolveFishSpeciesDetail,
  resolveWaterbodyDetail,
  resolveWaterbodyFilters,
  resolveAccessPoints,
  resolveFishingAreaDetail,
  resolveFishingReports,
  resolveMapLayers,
  resolveFishLandAccess,
  resolveAnimatedWind,
  resolveCatchData,
} from '@/services/feature-access/fish/operations'
import {
  DomainFeatureGates,
  getVerticalMembershipFeatureAccessResolver,
} from '@/services/feature-access/global'
import { Vertical } from '@/types/verticals'

export const fishFeatures = featureProvider({
  [FishClaims.species_detail]: {
    dependencies: [Dependency.CLAIMS, Dependency.MEMBERSHIP],
    resolver: resolveFishSpeciesDetail,
  },
  [FishClaims.waterbody_detail]: {
    dependencies: [Dependency.CLAIMS, Dependency.MEMBERSHIP],
    resolver: resolveWaterbodyDetail,
  },
  [FishClaims.waterbody_filters]: {
    dependencies: [Dependency.CLAIMS, Dependency.MEMBERSHIP],
    resolver: resolveWaterbodyFilters,
  },
  [FishClaims.access_points]: {
    dependencies: [Dependency.CLAIMS, Dependency.MEMBERSHIP],
    resolver: resolveAccessPoints,
  },
  [FishClaims.fishing_area_detail]: {
    dependencies: [Dependency.CLAIMS, Dependency.MEMBERSHIP],
    resolver: resolveFishingAreaDetail,
  },
  [FishClaims.fishing_reports]: {
    dependencies: [Dependency.CLAIMS, Dependency.MEMBERSHIP],
    resolver: resolveFishingReports,
  },
  [FishGates.layer_upsell]: {
    dependencies: [Dependency.MEMBERSHIP],
    resolver: resolveMapLayers,
  },
  [FishGates.land_access]: {
    dependencies: [Dependency.MEMBERSHIP],
    resolver: resolveFishLandAccess,
  },
  [DomainFeatureGates.search_this_area]: {
    dependencies: [Dependency.MEMBERSHIP],
    resolver: getVerticalMembershipFeatureAccessResolver(Vertical.Fish, []),
  },
  [DomainFeatureGates.search_map_markers]: {
    dependencies: [Dependency.MEMBERSHIP],
    resolver: getVerticalMembershipFeatureAccessResolver(Vertical.Fish, []),
  },
  [DomainFeatureGates.private_land_search]: {
    dependencies: [Dependency.MEMBERSHIP],
    resolver: getVerticalMembershipFeatureAccessResolver(Vertical.Fish, []),
  },
  [FishGates.animated_wind]: {
    dependencies: [Dependency.MEMBERSHIP],
    resolver: resolveAnimatedWind,
  },
  [FishGates.catch_data]: {
    dependencies: [Dependency.MEMBERSHIP, Dependency.FEATURE_FLAG_CLIENTS],
    resolver: resolveCatchData,
  },
})
